// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { spacing, typography } from "@recidiviz/design-system";
import { rem } from "polished";
import styled from "styled-components";

import { CopyWrapper } from "~@jii/common-ui";
import { useUsMaTranslations } from "~@jii/translation";
import { palette } from "~design-system";

const Wrapper = styled(CopyWrapper)`
  ${typography.Body14}
  // TODO(#10706): reduce line-height to 1.5 in Body styles
  line-height: 1.5;

  color: ${palette.slate85};
  margin-top: ${rem(spacing.xxl * 2)};
`;

export const Disclaimer = () => {
  const { t } = useUsMaTranslations();

  return <Wrapper>{t(($) => $.disclaimer)}</Wrapper>;
};
